export default {
  defaultColor: '#b2b2b2',
  backgroundTransparent: 'transparent',
  transparent: 'transparent',
  defaultBlue: '#0084ff',
  leftBubbleBackground: '#f0f0f0',
  carrot: '#e67e22',
  emerald: '#2ecc71',
  peterRiver: '#3498db',
  wisteria: '#8e44ad',
  alizarin: '#e74c3c',
  midnightBlue: '#2c3e50',
  optionTintColor: '#007AFF',
  timeTextColor: '#aaa',
  bot_blue: '#4B4EDE',

  red: '#FF0000',
  green: '#009933', //'#00FF00',
  blue: '#0000FF',
  cyan: '#00FFFF',
  magenta: '#FF00FF',
  yellow: '#FFFF00',
  black: '#000000',
  white: '#FFFFFF',
  gray: '#808080',
  silver: '#C0C0C0',
  maroon: '#800000',
  olive: '#808000',
  navy: '#000080',
  purple: '#800080',
  teal: '#008080',
  indigo: '#4B0082',
  orange: '#FFA500',
  pink: '#FFC0CB',
  violet: '#EE82EE',
  peach: '#FFDAB9',
  lavender: '#E6E6FA',
  coral: '#FF7F50',
  turquoise: '#40E0D0',
  chocolate: '#D2691E',
  lime: '#00FF00',
  gold: '#FFD700',
  crimson: '#DC143C',
  plum: '#DDA0DD',
  slate: '#708090',
  khaki: '#F0E68C',
  aquamarine: '#7FFFD4',
  bisque: '#FFE4C4',
  cornsilk: '#FFF8DC',
  firebrick: '#B22222',
  midnightblue: '#191970',
  text_color: '#444444',
  sub_text_color: '#A4A4A4',
  button_blue: '#303f9f',
  header_blue: '#2D5BCC',
};
